<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false"
			style="text-align: center;">
			<Transfer :data="data" :target-keys="targetKeys" @on-change="handleChange"></Transfer>
			<div slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">取消</Button>
				<Button type="success" size="large" @click="modalOk('add')">添加</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	export default {
		data() {
			return {
				modal: {
					Title: "站点分配",
					type: "add",
					ifShow: false,
					canInput: false
				},
				data: [{
						"key": "1",
						"label": "Content 1",
						"disabled": false
					},
					{
						"key": "2",
						"label": "Content 2",
						"disabled": true
					},
					{
						"key": "3",
						"label": "Content 3",
						"disabled": false
					}
				],
				targetKeys: ["1", "2"]
			};
		},

		methods: {
			handleChange: function(newTargetKeys, direction, moveKeys) {
				console.log(newTargetKeys);
				console.log(direction);
				console.log(moveKeys);
				this.targetKeys = newTargetKeys;
			}
		},

		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
				RoleList: 'roleList',
				OperatortypeList: 'typeList'
			})
		}
	}
</script>

<style>
</style>
